import { Store } from '@ngrx/store';
import { setFundChartSplitType } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/split-type/split-type.actions';
import { SPLIT_TYPE_OPTIONS } from 'ChartApp/ts/features/fundamental-chart/constants';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/radio-button-group/radio-button-group.component";
/**
 *
 * Fund Chart Panel Layout Component
 */
export class FundChartCreatorPanelLayoutComponent {
    constructor(store) {
        this.store = store;
        this.panelLayoutOptions = SPLIT_TYPE_OPTIONS;
        this.splitTypeObj = { value: '' };
        this.mapStateToComponent = (state) => {
            this.splitTypeObj = { value: state.fundChart.splitType };
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setChartSplitType(splitType) {
        this.store.dispatch(setFundChartSplitType({ splitType }));
    }
}
FundChartCreatorPanelLayoutComponent.ɵfac = function FundChartCreatorPanelLayoutComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartCreatorPanelLayoutComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FundChartCreatorPanelLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartCreatorPanelLayoutComponent, selectors: [["ycn-fund-chart-creator-panel-layout"]], standalone: false, decls: 5, vars: 2, consts: [[1, "panel-sidebar-section-header", "user-select-none"], [1, "panel-sidebar-section-title"], [1, "panel-sidebar-section-body", "user-select-none"], ["groupName", "panelLayout", 1, "custom-controls-stacked", 3, "selectHandler", "options", "selectedObject"]], template: function FundChartCreatorPanelLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2, "Panel Layout");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div", 2)(4, "ycn-radio-button-group", 3);
        i0.ɵɵlistener("selectHandler", function FundChartCreatorPanelLayoutComponent_Template_ycn_radio_button_group_selectHandler_4_listener($event) { return ctx.setChartSplitType($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.panelLayoutOptions)("selectedObject", ctx.splitTypeObj);
    } }, dependencies: [i2.RadioButtonGroupComponent], encapsulation: 2 });
